// Generated by purs version 0.13.8
"use strict";
var $foreign = require("/usr/src/app/www/.spago/strings/v4.0.2/src/Data/String/Common.js");
var Data_Ordering = require("/usr/src/app/www/.spago/prelude/v4.1.1/src/Data/Ordering.purs");
var $$null = function (s) {
    return s === "";
};
var localeCompare = $foreign["_localeCompare"](Data_Ordering.LT.value)(Data_Ordering.EQ.value)(Data_Ordering.GT.value);
module.exports = {
    "null": $$null,
    localeCompare: localeCompare,
    replace: $foreign.replace,
    replaceAll: $foreign.replaceAll,
    split: $foreign.split,
    toLower: $foreign.toLower,
    toUpper: $foreign.toUpper,
    trim: $foreign.trim,
    joinWith: $foreign.joinWith
};

